import React, { Suspense, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Route, Switch, useLocation, useHistory } from 'react-router';
import { ErrorBoundary } from 'react-error-boundary';

import SuspenseLoading from 'components/atoms/SuspenseLoading';
import PET_CONFIG from 'config/pet.config';
import ErrorFallback from 'pages/errorFallback/ErrorFallback';
import { isUserAuth } from 'utils/user/userAuth';
import { PetRoute } from 'utils/const';
import raygun from 'raygun.config';
import './App.scss';

const LoginAsync = React.lazy(() => import('pages/login/Login'));
const ListingsAsync = React.lazy(() => import('pages/listings/Listings'));
const NotFoundAsync = React.lazy(() => import('pages/notFound/NotFound'));
const ListingAsync = React.lazy(() => import('pages/listing/Listing'));

const { Login, Home, Listing, Listings } = PetRoute;

function App() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    document.title = PET_CONFIG.app.name;
  }, []);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(err) => raygun.logError(err)}
      resetKeys={[location.pathname]}
      onReset={() => history.push(Home)}
    >
      <Suspense fallback={<SuspenseLoading />}>
        <Switch>
          <Route path={Login} component={LoginAsync} />
          <PrivateRoute path={Home} component={ListingsAsync} />
          <PrivateRoute
            path={`${Listings}/:status`}
            component={ListingsAsync}
          />
          <PrivateRoute
            exact={true}
            path={`${Listing}/:listingId/:viewMode?`}
            component={ListingAsync}
          />
          <Redirect from="/" exact to={Home} />
          <Route path="*" component={NotFoundAsync} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
}

const PrivateRoute = ({
  component: Component,
  ...rest
}: {
  component: any;
  path: string;
  exact?: boolean;
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isUserAuth()) {
          return (
            <Redirect
              to={{
                pathname: Login,
                // eslint-disable-next-line react/prop-types
                state: { from: props.location },
              }}
            />
          );
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

export default App;
